import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { APPLICABLE_GRADES } from "../apiRoutes";

// Define the expected response type
interface Grade {
  curriculumId: string;
  curriculumGrade: string;
  description?: string;
  isActive: boolean;
}

interface GradesResponse {
  data: Grade[];
}

const fetchApplicableGrades = async () => {
  const response = await axiosAuth.get<GradesResponse>(APPLICABLE_GRADES);
  return response.data;
};

export const useGetApplicableGradesQuery = (
  queryParams?: UseQueryOptions<GradesResponse, Error, GradesResponse, ["applicableGrades"]>
) =>
  useQuery<GradesResponse, Error, GradesResponse, ["applicableGrades"]>({
    queryKey: ["applicableGrades"],
    queryFn: fetchApplicableGrades,
    ...(queryParams as any),
  });
